import { URLS, ck } from "fire-wind-water";
declare const $sk: any;

const utm_source = URLS.getURL("utm_source");
const utm_medium = URLS.getURL("utm_medium");
const utm_campaign = URLS.getURL("utm_campaign");
const utm_content = URLS.getURL("utm_content");
const utm_term = URLS.getURL("utm_term");

if (utm_source) {
  ck.cookie("utmSource", JSON.stringify(decodeURIComponent(utm_source)), {
    domain: $sk.config.domain,
    path: "/",
  });
}
if (utm_medium) {
  ck.cookie("utmMedium", JSON.stringify(decodeURIComponent(utm_medium)), {
    domain: $sk.config.domain,
    path: "/",
  });
}
if (utm_campaign) {
  ck.cookie("utmCampaign", JSON.stringify(decodeURIComponent(utm_campaign)), {
    domain: $sk.config.domain,
    path: "/",
  });
}
if (utm_content) {
  ck.cookie("utmContent", JSON.stringify(decodeURIComponent(utm_content)), {
    domain: $sk.config.domain,
    path: "/",
  });
}
if (utm_term) {
  ck.cookie("utmTerm", JSON.stringify(decodeURIComponent(utm_term)), {
    domain: $sk.config.domain,
    path: "/",
  });
}
